import { type EndpointMethodKeys, type EndpointsShapeWithNamespaces } from './create-api.model';

const httpMethods = new Set(['get', 'post', 'put', 'delete', 'patch'] satisfies EndpointMethodKeys[]);

/** endpoint shape type guard */
const isNameSpacedEndpointShape = (shape: unknown): shape is EndpointsShapeWithNamespaces => {
    if (!shape || typeof shape !== 'object') return false;
    const hasHttpMethodKeys = Object.keys(shape).every(key => httpMethods.has(key as any));
    return !hasHttpMethodKeys;
};

export { isNameSpacedEndpointShape };
